import Component from '~/components/component';

export default class TextVideoBlock extends Component {
	constructor(...args) {
		super(...args);
		this.poster = this.dom.component.querySelector('.js-video-poster');
		this.player = this.dom.component.querySelector('.youtube_player');
		this.iframe = this.player.querySelector('iframe');
		this.playIcon = this.dom.component.querySelector('.icon');
	}

	init() {
		this.bindEvents();
		this.setVideoSize();
		window.addEventListener('resize', this.setVideoSize.bind(this));
	}

	bindEvents() {
		this.poster.addEventListener('click', () => this.showVideo());
	}

	showVideo() {
		this.poster.style.display = 'none';
		this.playIcon.style.display = 'none';
		this.player.style.display = 'block';
	}

	setVideoSize() {
		const posterHeight = this.poster.clientHeight;
		const posterWidth = this.poster.clientWidth;

		this.player.style.width = `${posterWidth}px`;
		this.player.style.height = `${posterHeight}px`;
	}

	unbind() {
		this.poster.removeEventListener('click', this.showVideo);
		window.removeEventListener('resize', this.setVideoSize.bind(this));
	}
}
